import { Component } from 'react';
import ManualClusterSelect from '../../../components/manualClusterModal';

class ExtraButtons extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;
        return (
            <>
                <div className="table-additional-view justify-content-between align-items-center">
                    <div>
                        {!!this.props.selectedItems?.length && (
                            <div>
                                <ManualClusterSelect
                                    current_url={this.props.endpoint_url}
                                    csrf_token={this.props.csrf_token}
                                    selectedItems={this.props.selectedItems}
                                    cluster_type="url"
                                    header={t('search.list_keywords.add_to_urls_list')}
                                    onRemoveAllSelected={this.props.onRemoveAllSelected}
                                />
                            </div>
                        )}
                    </div>
                    <div className="d-flex gap-8">
                        <div>
                            <a href="/domains/get-user-domains/" className="add-cluster-btn">
                                {t('search.list_keywords.see_ignored_keywords')}
                            </a>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default ExtraButtons;
